// Mock data for J. CROWN artist website
// NOTE: Streaming links, store URL, social links, and email are PLACEHOLDERS.

export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_coco-jones-site/artifacts/ehm8vxk4_F1933921-EBD7-4B65-9D73-5AEFCE107382.PNG",
  albumCover: "https://customer-assets.emergentagent.com/job_coco-jones-site/artifacts/ktgz54cy_C8D64B52-36BC-445C-9F4F-6FDE0CA25D9C.PNG",
};

export const ARTIST = {
  name: "J. CROWN",
  tagline: "KING \u2014 Keep Inspiring New Generations",
  taglineShort: "Keep Inspiring New Generations",
  contactEmail: "info@goodman-entertainment.com",
};

// ===== FEATURE FLAGS =====
// Flip storeEnabled back to true to reactivate the full merch store,
// the hero "Shop Merch" button, the "The Collection" nav link, and the
// Diggers Factory vinyl pre-order. All product data below is preserved.
export const FEATURES = {
  storeEnabled: false,
};

export const NAV_LINKS = [
  { label: "The Music", href: "#music" },
  ...(FEATURES.storeEnabled ? [{ label: "The Collection", href: "#merch" }] : []),
  { label: "The King", href: "#about" },
  { label: "Gallery", href: "#gallery" },
  { label: "Connect", href: "#connect" },
];

// ===== OFFICIAL VEVO VIDEOS =====
// Add/replace your YouTube video IDs below. (ID = the part after "watch?v=")
export const VEVO_VIDEOS = [
  { id: "O7koVp10WqY", title: "J. Crown — Official Video" },
  { id: "gypdRXnhiqs", title: "J. Crown — Official Video" },
];

// ===== EDIT YOUR LINKS HERE =====
// Paste your real streaming URLs below (replace the "#").
export const STREAMING = [
  { label: "Spotify", href: "https://open.spotify.com/artist/2gEdAAuPOMz00LVl3jzs2v?si=kmGa-SuZSpCSHVBKmTKThg&utm_source=copy-link" },
  { label: "Apple Music", href: "https://music.apple.com/us/album/king-ep/6796492766" },
  { label: "YouTube", href: "https://youtube.com/@j.crownmusic?si=erLCpeFfCRxC6kKu" },
];

export const ALBUM = {
  title: "KING",
  cover: ASSETS.albumCover,
  description:
    "A regal body of work born from ambition and faith. KING is J. Crown\u2019s coronation \u2014 a cosmic blend of hard-hitting hip-hop and uplifting purpose, crafted to inspire the next generation to rise and wear their own crown.",
};

export const TRACKLIST = [
  { no: "01", title: "Dedicated", lead: false },
  { no: "02", title: "Grateful", lead: false },
  { no: "03", title: "Secret Agents", lead: true },
  { no: "04", title: "Manifest", lead: false },
  { no: "05", title: "Bake With Us", lead: false },
  { no: "06", title: "Crown", lead: false },
];

export const MERCH = [
  {
    id: "m1",
    title: "Store Chains Tee \u2014 Black",
    price: "$40.00",
    image: "https://customer-assets.emergentagent.com/job_coco-jones-site/artifacts/hb4fi5xq_B7F9AC99-1B96-477E-B05B-27113D8A0D32%202.PNG",
  },
  {
    id: "m2",
    title: "Meditation Tee \u2014 Black",
    price: "$40.00",
    image: "https://customer-assets.emergentagent.com/job_coco-jones-site/artifacts/uw5khwzv_1F63039F-6402-45F3-823C-0A28032091A3.PNG",
  },
  {
    id: "m3",
    title: "Wear The Crown Tee \u2014 Black",
    price: "$40.00",
    image: "https://customer-assets.emergentagent.com/job_coco-jones-site/artifacts/xfuqave7_C6029258-A4A5-4560-B36B-0F1A80CE2A7A.png",
  },
  {
    id: "m4",
    title: "J. Crown Poster \u2014 Cosmic King",
    price: "$25.00",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_coco-jones-site/artifacts/xwtbaukt_IMG_6362.jpeg",
    description:
      "Limited edition art print. J. Crown enthroned in gold and cosmic light \u2014 the KING era captured in one regal frame. Premium poster stock, ready to crown any wall.",
  },
  {
    id: "m5",
    title: "KING \u2014 Limited Edition Gold Vinyl",
    price: "$54.99",
    image: "https://customer-assets.emergentagent.com/job_coco-jones-site/artifacts/2hpydac9_13174AC1-63B6-4522-BADF-F37F0DE815B8.png",
    badge: "PRE-ORDER",
    link: "https://www.diggersfactory.com/vinyl/335114", // Diggers Factory pre-order
    description:
      "KING, pressed on collector\u2019s gold vinyl. Six tracks of hard-hitting, soul-lifting hip-hop on a limited-edition metallic gold record, housed in full-color cosmic cover art with a custom gold-foil label. A crown for your shelf. Numbered, limited, and built to last \u2014 because some things you don\u2019t stream, you keep.",
  },
];

export const ABOUT_BIO =
  "J. Crown makes hip-hop with a crown on its head and a message in its chest. Blending hard-hitting bars with new-age spirit \u2014 manifestation, gratitude, and the grind \u2014 his debut album KING turns struggle into strategy and pain into purpose. It\u2019s music you can nod to and grow from: catchy enough for the club, deep enough for the soul. Built on a simple mission \u2014 Keep Inspiring New Generations \u2014 J. Crown carves a lane where positivity hits as hard as any punchline. From the fake-friend anthem \u2018Secret Agents\u2019 to the grateful heart of the album, every track reminds the listener of one thing: you were born to wear the crown. Now go pass it down.";

// ===== PRESS PHOTOS / GALLERY =====
export const GALLERY = [
  { id: "g1", src: "https://customer-assets-39nsmqrw.emergentagent.net/job_coco-jones-site/artifacts/e8iuku4h_C478AC81-F866-4B1F-AB61-C1CA975E1877.webp", alt: "J. Crown enthroned" },
  { id: "g2", src: "https://customer-assets-39nsmqrw.emergentagent.net/job_coco-jones-site/artifacts/f74o24eh_IMG_7091.webp", alt: "J. Crown portrait" },
  { id: "g3", src: "https://customer-assets-39nsmqrw.emergentagent.net/job_coco-jones-site/artifacts/1f9kjivi_J.crown_new%20pic1.webp", alt: "J. Crown poolside" },
  { id: "g4", src: "https://customer-assets-39nsmqrw.emergentagent.net/job_coco-jones-site/artifacts/72cmipz2_J.crown_new%20pic2.webp", alt: "J. Crown in doorway" },
  { id: "g5", src: "https://customer-assets-39nsmqrw.emergentagent.net/job_coco-jones-site/artifacts/6g3u824c_J.crown_new%20pic3.webp", alt: "J. Crown on set" },
];


// Paste your real store URL below (replace the "#").
export const STORE_URL = "#"; // <-- paste your store/shop URL

// ===== EDIT YOUR SOCIAL LINKS HERE (replace the "#") =====
export const SOCIALS = [
  { label: "Instagram", key: "instagram", href: "https://www.instagram.com/kingjcrown?igsh=NTc4MTIwNjQ2YQ%3D%3D&utm_source=qr" },
  { label: "TikTok", key: "tiktok", href: "#" },       // <-- paste TikTok URL
  { label: "YouTube", key: "youtube", href: "https://youtube.com/@j.crownmusic?si=erLCpeFfCRxC6kKu" },
  { label: "X", key: "x", href: "https://x.com/kingjcrown?s=11" },
];
